if (!customElements.get('read-more-content')) {
  const DEFAULT_MAX_HEIGHT = 100;

  customElements.define(
    'read-more-content',
    class ReadMoreContent extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.read-more__content');
        this.toggle = this.querySelector('.read-more__toggle');
        this.moreLabel = this.querySelector('.read-more__toggle-more');
        this.lessLabel = this.querySelector('.read-more__toggle-less');

        if (!this.content || !this.toggle) return;

        const maxHeight = parseInt(this.dataset.maxHeight, 10) || DEFAULT_MAX_HEIGHT;
        this.style.setProperty('--read-more-max-height', `${maxHeight}px`);

        requestAnimationFrame(() => {
          if (this.content.scrollHeight > maxHeight) {
            this.classList.add('is-clampable');
            this.toggle.hidden = false;
          }
        });

        this.toggle.addEventListener('click', this.onToggleClick.bind(this));
      }

      onToggleClick() {
        const expanding = !this.classList.contains('is-expanded');

        if (expanding) {
          this.style.setProperty('--read-more-expanded-height', `${this.content.scrollHeight}px`);
        }

        const expanded = this.classList.toggle('is-expanded');
        this.moreLabel.hidden = expanded;
        this.lessLabel.hidden = !expanded;
        this.toggle.setAttribute('aria-expanded', expanded);
      }
    }
  );
}
